// extracted by mini-css-extract-plugin
module.exports = {"submittedSelect":"submittedSelect--n1jDt","btn":"btn--LN3XQ","wrapper":"wrapper--5XXpg","row":"row--26+s2","colXs":"colXs--5+qwk","colSm":"colSm--yWTni"};